import {
  RecognizeExportFilters,
  RecognizeExportFormat,
} from "@redotech/redo-recognize-common/export";
import * as z from "zod";

export const getRecognizeExportCount = {
  name: "getRecognizeExportCount" as const,
  input: RecognizeExportFilters.extend({ format: RecognizeExportFormat }),
  output: z.object({ count: z.number().int().nonnegative() }),
};
